import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // Data considered fresh for 30 seconds
      gcTime: 5 * 60 * 1000, // Garbage collection after 5 minutes (formerly cacheTime)
      retry: 2, // Retry failed requests twice
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000), // Exponential backoff
      refetchOnWindowFocus: false, // Don't refetch on window focus to reduce API calls
      refetchOnReconnect: true, // Refetch when connection restored
    },
    mutations: {
      retry: 1, // Retry mutations once
      onError: (error) => {
        console.error('[Mutation Error]', error);
      },
    },
  },
});
